// extracted by mini-css-extract-plugin
export default {"message":"_2IfIZ","countdown":"_1tZvQ","countdown-value":"_1iWwc","countdownValue":"_1iWwc","countdown-ended":"_2cSxV","countdownEnded":"_2cSxV"};